import OneTimePassContainer from '@/portal/one-time-pass/one-time-pass-container/OneTimePassContainer.vue';

import AssessmentPage from '@/portal/one-time-pass/assessment-page/AssessmentPage.vue';
import CriteriaSummary from '@/portal/one-time-pass/criteria-summary/CriteriaSummary.vue';
import InductionPage from '@/portal/one-time-pass/induction-page/InductionPage.vue';
import WelcomePage from '@/portal/one-time-pass/welcome-page/WelcomePage.vue';
import SuccessPage from '@/portal/one-time-pass/success-page/SuccessPage.vue';
import NotFound from '@/portal/one-time-pass/not-found/NotFound.vue';

import oneTimePassGuards from '@/portal/one-time-pass/one-time-pass.guards';

const workerOTPInitialised = [
  oneTimePassGuards.hasOneTimePass,
  oneTimePassGuards.workerCreated,
  oneTimePassGuards.workerOneTimePassCreated,
];

const workerOTPInProgressGuards = [
  ...workerOTPInitialised,
  oneTimePassGuards.canAccessOneTimePass,
  oneTimePassGuards.workerOTPNotRedeemed,
  oneTimePassGuards.hasWorkerAssessment,
];

export default [
  {
    path: '/one-time-pass',
    component: OneTimePassContainer,
    redirect: {
      name: 'oneTimePassWelcome',
    },
    children: [
      {
        path: 'welcome',
        name: 'oneTimePassWelcome',
        component: WelcomePage,
        meta: {
          guards: [
            ...workerOTPInitialised,
            oneTimePassGuards.hasWorkerAssessment,
            oneTimePassGuards.workerOTPNotCompleted,
          ],
          title: 'One Time Pass - Get Started',
        },
      },
      {
        path: 'not-found',
        name: 'oneTimePassNotFound',
        component: NotFound,
        meta: {
          title: 'One Time Pass - Not Found',
        },
      },
      {
        path: 'assessment/:assessmentFieldUuid?',
        name: 'oneTimePassAssessment',
        component: AssessmentPage,
        meta: {
          guards: [
            ...workerOTPInProgressGuards,
            oneTimePassGuards.workerOTPHasAssessmentFields,
          ],
          title: 'One Time Pass - Assessment',
        },
      },
      {
        path: 'criteria-summary',
        name: 'oneTimePassCriteriaSummary',
        component: CriteriaSummary,
        meta: {
          guards: [
            ...workerOTPInProgressGuards,
            {
              ...oneTimePassGuards.hasWorkerInductions,
              redirectOnFail: {
                name: 'oneTimePassReviewApplication',
              },
            },
            oneTimePassGuards.workerOTPHasAssessmentFields,
          ],
          title: 'One Time Pass - Criteria',
        },
      },
      {
        path: 'induction/:inductionUuid?',
        name: 'oneTimePassInduction',
        component: InductionPage,
        meta: {
          guards: [
            ...workerOTPInProgressGuards,
            oneTimePassGuards.hasWorkerInductions,
          ],
          title: 'One Time Pass - Induction',
        },
      },
      {
        path: 'review-application',
        name: 'oneTimePassReviewApplication',
        component: CriteriaSummary,
        meta: {
          guards: [
            ...workerOTPInitialised,
            oneTimePassGuards.canAccessOneTimePass,
            oneTimePassGuards.workerOTPCompleted,
            oneTimePassGuards.hasWorkerAssessment,
          ],
          title: 'One Time Pass - Review Application',
        },
        props: {
          completed: true,
        },
      },
      {
        path: 'success',
        name: 'oneTimePassSuccess',
        component: SuccessPage,
        meta: {
          guards: [
            ...workerOTPInitialised,
            oneTimePassGuards.canAccessOneTimePass,
            oneTimePassGuards.workerOTPCompleted,
          ],
          title: 'One Time Pass - Success',
        },
      },
    ],
  },
];
